// Beschriftung eines Vario-Variantenattributs fuer Auswahllisten. Bewusst pur und ohne DOM, damit
// die Formulierung testbar bleibt und settings-page.ts nicht weiter waechst.

export interface AttributeChoice {
  id: string;
  label: string;
  values?: ReadonlyArray<{ label: string }>;
}

/** Wie viele Beispielwerte hinter dem Namen stehen. Drei reichen, um S/M/L von 36/37/38 zu trennen. */
const SAMPLE_COUNT = 3;

/**
 * „Größe — S, M, L …" statt nur „Größe".
 *
 * Grund (Betreiber 2026-07-29): „Wenn beide den gleichen Namen haben und ich keine weiteren
 * anhaltspunkte habe, welcher wofür ist, kann ich das nur zufällig auswählen." Genau so entstand
 * beim Konflikt-Test eine vertauschte Zuordnung — formal ohne Kollision, inhaltlich falsch, und
 * still: Attribut und gemappte Werte gehoerten danach zu verschiedenen Dimensionen.
 *
 * Ohne Werte wird das benannt („noch keine Werte"), damit ein leeres Attribut nicht wie eines mit
 * unbekanntem Inhalt aussieht. Leere und nur aus Leerzeichen bestehende Labels fallen weg.
 */
export function attributeChoiceLabel(attr: AttributeChoice): string {
  const name = attr.label.trim().length > 0 ? attr.label.trim() : 'ohne Namen';
  const samples = (attr.values ?? [])
    .map((v) => v.label.trim())
    .filter((l) => l.length > 0);
  if (samples.length === 0) return `${name} — noch keine Werte`;
  const shown = samples.slice(0, SAMPLE_COUNT).join(', ');
  return samples.length > SAMPLE_COUNT ? `${name} — ${shown} …` : `${name} — ${shown}`;
}
